import { createApiConstants } from '@saucelabs/sl-util-redux';

export const NAMESPACE = 'jobs-filters';
const createApiNamespacedConstants = createApiConstants.bind(null, NAMESPACE);

export const CLEAR_OWNER = `${NAMESPACE}/CLEAR_OWNER`;
export const CLEAR_STATUSES = `${NAMESPACE}/CLEAR_STATUSES`;
export const INITIALIZE_FILTERS = `${NAMESPACE}/INITIALIZE_FILTERS`;
export const RESET_FILTERS = `${NAMESPACE}/RESET_FILTERS`;
export const SELECT_OWNER = `${NAMESPACE}/SELECT_OWNER`;
export const SELECT_STATUSES = `${NAMESPACE}/SELECT_STATUSES`;
export const SET_SEARCH = `${NAMESPACE}/SET_SEARCH`;
export const TOGGLE_PERFORMANCE = `${NAMESPACE}/TOGGLE_PERFORMANCE`;
export const TOGGLE_STATUS = `${NAMESPACE}/TOGGLE_STATUS`;
export const UPDATE_OWNER = `${NAMESPACE}/UPDATE_OWNER`;
export const UPDATE_FILTERS_FROM_LS = `${NAMESPACE}/UPDATE_FILTERS_FROM_LS`;
export const GET_ORG_USERS = createApiNamespacedConstants('GET_ORG_USERS');
export const TEAMLIST_GET = createApiNamespacedConstants('TEAMLIST_GET');
export const GET_USERS = createApiNamespacedConstants('GET_USERS');
